export const PIIClassName = 'fs-mask';

export const getPIIClassName = (PII?: boolean): string => (PII ? PIIClassName : '');
